import { Route, Routes } from "react-router-dom";
import CategorySubmitForecastPageLoader from "./CategorySubmitForecastPageLoader";
import CategorySubmitHistoryPage from "./CategorySubmitHistoryPage";
import ForecastCategoriesPage from "./ForecastCategoriesPage";
import SubmissionDetailPage from "./SubmissionDetailPage";

const ForecastCategoryRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route index element={<ForecastCategoriesPage />} />
        <Route path=":id" element={<CategorySubmitForecastPageLoader />} />
        <Route path=":id/submissions" element={<CategorySubmitHistoryPage />} />
        <Route
          path=":id/submissions/:submissionId"
          element={<SubmissionDetailPage />}
        />
      </Route>
    </Routes>
  );
};

export default ForecastCategoryRoutes;
